import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";
import Default from "./Default";
import AB_2659 from "./AB_2659";

const abTests = {
    dev_2659__v2: loadUsualComponent(AB_2659),
};

const ButtonUi = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default ButtonUi;
